import {ReactElement} from 'react';

import {isRightToLeft} from 'js-libs/sweetcommons/rtl';
import ReactDOMServer from 'react-dom/server';

export const isRightToLeftWrapper = (
  textOrNode: string | ReactElement
): boolean => {
  let text = textOrNode;

  if (typeof text !== 'string') {
    text = ReactDOMServer.renderToString(text);
  }

  return isRightToLeft(text);
};
